var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1573_4968)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM2 5.45C2 5.33954 2.08954 5.25 2.2 5.25H7.43822L6.05858 3.87036C6.02107 3.83285 6 3.78198 6 3.72894V2.1733C6 1.99512 6.21543 1.90589 6.34142 2.03188L9.77941 5.46987C10.0723 5.76276 10.0723 6.23764 9.77941 6.53053L6.34142 9.96852C6.21543 10.0945 6 10.0053 6 9.8271V8.27146C6 8.21842 6.02107 8.16755 6.05858 8.13004L7.43862 6.75H2.2C2.08954 6.75 2 6.66046 2 6.55V5.45Z",
    fill: "#6FB9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1573_4968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceSent);
export default __webpack_public_path__ + "static/media/invoice-sent.0f6fd37608b98336e3c5f6e6d25e4785.svg";
export { ForwardRef as ReactComponent };